
        <!-- 交易流水 -->
<template>
 <!-- <vue-scroll :ops="ops" style="width:100%;min-height:95%;"> -->
    <div class="financeSetA"> 

       
   <div class="navCalss">
       | 价格管理
   </div>
         <el-form
        :model="price"
        :rules="price.form_rules"
        ref="search"
        
        label-position="left"
      >
  <div class="wrl-hea" v-if="editStatus">
      <div>
      当前价格系数：
      <span class="wrl-font">
          {{sytemPrice}}
      </span>
      </div>
      <div class="ss">
        <el-button @click="edit(sytemPrice)" type="text" style="margin-left:20px">修改</el-button>
      </div>
  </div>
        <div class="wrl-hea" v-else>
     
      <div>
      当前价格系数：
      
      </div>
      <el-form-item prop="editPrice" >
     <el-input v-model="price.editPrice" style="width:200px" placeholder="请输入大于0的数字"></el-input>
      </el-form-item>
      <div style="margin-left:20px">
       <el-button @click="editB(price.editPrice)" type="primary">确认修改 </el-button>
 <el-button @click="editStatus==true" type="primary">取消 </el-button>
      </div>
  </div>
         </el-form>
<div style="margin-top:10px">
    备注：价格计价公式如下
</div>
<div style="margin-top:10px">
  单个商品：
</div>
<div style="margin-left:20px">
  <div style="margin-top:10px">
       按体积算：（长*宽*高 / 6000） * 价格系数
  </div>
    <div style="margin-top:10px">
        按重量算：千克重量* 价格系数
  </div>
</div>
<div style="margin-top:10px">
    然后取体积和重量二者之间的较大值为单个商品的运费
</div>
<div style="margin-top:10px">
   最后，一类物品的运费为单个商品运费 x 商品数量，订单运费为多类物品运费之和
</div>
    </div>
    <!-- </vue-scroll> -->
</template>
<script>
import * as mUtils from 'utils/mUtils'
import * as confirm from '@/api/confirm'
import Draggable from "vuedraggable"
  import Sortable from 'sortablejs'
  import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
    import {
        axios
    } from 'utils/'
export default {
      components: {
    Draggable
  },
    data() {
        let dataValidate = (rule, value, callback) => {
           
            let that=this
      if (value === "") {
        let text;
        if (rule.field == "editPrice") {
          text = "价格系数不能为空";
        } else if (rule.field == "bankUser") {
          text = "账户名";
        }
         else if (rule.field == "bankName") {
          text = "开户行";
        }
        else if (rule.field == "sytemPrice") {
          text = "商品现价";
        }  else if (rule.field == "stock") {
          text = "商品库存";
        }
    
        callback(new Error(text + "不能为空~"));
      } else {
           if (rule.field == "editPrice") {
          let numReg = /^[0-9]+.[0-9]+$/;
          if (!numReg.test(value)) {
             
            callback(new Error("请输入数字"));
          }else {
              if(value<0){
                 callback(new Error("请输入大于0数字"));
              }
               
          }
        }
        return callback();
      }
    };
  
        return {
            editStatus:true,
        sytemPrice:'3.8',
        price:{
        editPrice:'',
             //信息修改规则
        form_rules: {
          editPrice: [
           {
              required: true,
              validator: dataValidate,
              
              trigger: "blur"
            }
          ]
        }
        }
        }
    },
    created() {
        let that=this
        that. getConfig()
     
    },
    methods: {
         getConfig(){
          let that=this
            const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function(){
              loading.close();
            },5000)
          confirm.getPrice({}).then((res)=> {
              that.sytemPrice=res.data.data.price
              loading.close();
          })
      },
    edit(val){
        let that=this
         that.price.editPrice=val
        that.editStatus=false
       
    },
    editB(val){
          let that=this
        //  that.editPrice=that.sytemPrice
        that.editStatus=true
        //  let that = this
               let numReg =/^\d+(\.\d+)?$/;;
           
     if (!numReg.test(val)) {
            that.$message.warning("请输入数字")
            return
          }else{
    if(val<0){
                 that.$message.warning("请输入大于等于0的值")
                 return
               } 
          }
                 const loading = this.$loading({
					lock: true,
					text: 'loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
                });
     
        setTimeout(function(){
              loading.close();
            },5000)
 let validd
            that.$refs.search.validate((valid) => {
                validd = valid;
    
                return true
            }) 
           let data={
             price:val
           }
            if(validd){
              
                confirm.updatePrice(data)
        .then((res)=> {
          if(res.data.code == 0) {
            
                that.$message.success('提交成功 !') 
                that. getConfig()
          }else{
               that.$message.error('提交错误 !')
          }
          })
                   loading.close();
       }else{
                 that.$message.error('表单输入错误 !')
                loading.close();
                return false
            }
        
    },
    }
}
</script>
<style  lang="less" scoped>
.wrl-hea{
    margin-top: 30px;
    display: flex;
    line-height: 40px;
    height: 40px;
    .wrl-font{
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: normal;
            font-size: 18px;

    }
}
.financeSetA{
    margin:20px 50px ;

.monewt{
    margin: 20px 0px;
    // border: 1px solid rgba(121, 121, 121, 1);
    min-height: 50px;
    min-width: 900px;
}
}
.pagination{
    margin: 20px 0;
}
.backakdia{
background:#DCDFE6 ;
line-height: 30px;
min-height: 30px;

}
  .ss{
		cursor: pointer;
		color: #409EFF;
  }
    .navCal{
      margin: 20px 0;
  
  }
    .navCalss{
          font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC', sans-serif;
    font-weight: 650;
        font-size: 18px ;
  }
  	.ellipsis{
		// max-width: 150px;
		max-height: 20px;
		//  overflow: hidden;
		white-space: pre-wrap	;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
	   
  }
   	.ellipsisB{
		max-width: 500px;
		max-height: 20px;
		//  overflow: hidden;
		white-space: pre-wrap	;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
	   
  }
  .wel-flex{
    display: flex;
    justify-content: left;
    align-items: center;
    margin:10px 0
  }
  .wrl-hedaNa{
    margin: 10px 0;
  }
  .wrl-productList{
    margin: 20px 0;
  }
  .wrl-border{
    height: 2px;
     margin: 20px 0;
    background-color: #D7D7D7;
  }
.wrl-marign{
  margin:0 30px
}
.wrl-flex2{
  display: flex;
  margin:10px 0 ;
  justify-content: start;
  align-items: center;
  .wrl-felx4{
width: 700px;
  }
  .wrl-felx5{
    	max-width: 700px;
  }
   .wrl-felx6{
    	margin-left: 10px;
  }
}
.wrl-felxz{
    margin:10px 30px;
    display: flex;
    justify-content: space-between;

    .wrl-left{
      flex:1;
      .wrl-felxz1{
       display: flex;
      }
    }
}
 .backgroundA{
 background-image: url('../../assets/img/u69.svg');
         min-height: 80px;
    line-height: 80px;
    margin: 24% 30%;
    color:white;
    background-repeat: no-repeat
    }
    .avatar{
      min-height: 80px;
      width: 80px;
    }
    .wlr-header{
      display: flex;
      
      .wlr-start{
        display: flex;
            justify-content: start;
      }
    }
.inpoutTop{
  margin-top:5px;
  
}
.space{
  margin: 0 5px;
}
.wrl-flex56{
display: flex;
margin-right:20px ;
justify-content: flex-end;
    font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
    font-weight: 400;
    font-style: normal;
    color: #EC808D;
}
.wrl-flex57{
// width: 177px;
margin-top: 10px;
display: flex;
justify-content: center;
}
</style>
<style>

   .navCal .is-active{
          background-color: rgba(2, 125, 180, 1);
          color: white !important;
      }
     .inpout    .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 30px;
    line-height: 30px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
       /* .scrt{
         overflow-x:hidden;
         overflow-y:scroll
       } */
</style>



// WEBPACK FOOTER //
// priceContort.vue?4d44a384